/**
 * Species values are stored as a single string with multiple species
 * separated by a semicolon, e.g. "Rhino; Pangolin; Elephant; Hippopotamus"
 * (a comma is tolerated too, in case a record ever uses one). Splits that
 * into individual, trimmed, non-empty species names — callers that were
 * splitting on "," alone were treating a whole multi-species record as a
 * single combined "species".
 */
export function splitSpecies(raw: string | null | undefined): string[] {
  if (!raw) return [];
  return raw
    .split(/[;,]/)
    .map((s) => s.trim())
    .filter(Boolean);
}
